function animationTimeline(limitInf, limitSupp, stepList) {
    let startTime = null;
    let elapsedTime = 0;
    let isRunning = false;
    let direction = 1;  // 1 means forward, -1 means backward
    let lastTimestamp = 0;
    let resolvePromise = null;  // Store the resolve function of the promise

    // The frame callback function
    function frame(timestamp) {
        if (!isRunning) return;

        if (startTime === null) {
            startTime = timestamp;  // Initialize start time on first frame
            lastTimestamp = startTime;
           

        }
        // Calculate the delta time and update elapsed time
        const delta = timestamp - lastTimestamp;
        lastTimestamp = timestamp;
        

        elapsedTime += direction * delta;

        // Log elapsed time for debugging
       const advancement=elapsedTime/1000;
        if(stepList.length>0){
            if(stepList[0].timing<=advancement){
                stepList[0].action();
                    stepList.shift();
                    
             }
        }
        // Stop if elapsed time reaches or exceeds 1 second
        if (elapsedTime >= limitSupp || elapsedTime < limitInf) {
            stop();
            if (resolvePromise) resolvePromise();  // Resolve the promise when time reaches 1 second
        }
    
        if (isRunning) {
            requestAnimationFrame(frame);  // Continue the animation frame loop
        }
    }

    // Start or resume the animation loop, and return a Promise
    function start() {
        return new Promise((resolve) => {
            if (!isRunning) {
                resolvePromise = resolve;  // Store resolve function to be called later
                isRunning = true;
                lastTimestamp = 0;  // Reset the timestamp for accurate delta calculation
                elapsedTime = 0;  // Reset elapsed time
                startTime=null;
                requestAnimationFrame(frame);  // Start the animation loop

            }
        });
    }

    // Stop the animation loop
    function stop() {
        isRunning = false;
    }

    // Reverse the direction of elapsed time (forward or backward)
    function reverse() {
        direction = -direction;
    }

    // Reset the elapsed time and the internal state
    function reset() {
        startTime = null;
        elapsedTime = 0;
        lastTimestamp = 0;
        direction = 1;
        if (isRunning) {
            stop();
            start();  // Restart the animation loop after reset
        }
    }

    return {
        start,
        stop,
        reverse,
        reset
    };
}
export {animationTimeline}